module.exports = __webpack_public_path__ + "img/user-profile-icon.a5e9e2f8.svg";